import React from 'react';

const SlideInContext = React.createContext();
export default SlideInContext;
